import { NavLink } from 'react-router-dom';

import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { useQuerySuffix } from '../widget-hooks/useQuerySuffix';
import { PATH } from '../widget-lib/path-routes';
import { EmbedFeedbackButton } from './EmbedFeedbackButton';

/**
 * Юридические ссылки: hit area не меньше 48 dp по высоте (mobile touch target),
 * при этом визуально footer остаётся компактным — отрицательные margin компенсируют
 * добавленную высоту и горизонтальные отступы.
 */
const linkClass =
  'inline-flex min-h-12 -mx-1 items-center justify-center rounded-sm px-1 text-[11px] text-[var(--text-muted)] underline decoration-[var(--border)] underline-offset-2 hover:text-[var(--text)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-elevated)]';

export type EmbedSiteFooterProps = {
  className?: string;
};

export function EmbedSiteFooter({ className = '' }: EmbedSiteFooterProps) {
  const suffix = useQuerySuffix();
  const { accessToken, orgSlug } = useEmbedBootstrap();
  return (
    <footer
      className={`border-t border-[var(--border)] bg-[var(--bg-elevated)]/80 py-3 text-center ${className}`.trim()}
      aria-label="Юридическая информация"
    >
      <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-2 px-3">
        <NavLink to={`${PATH.legalCrm}${suffix}`} className={linkClass}>
          Публичная оферта
        </NavLink>
        <span className="hidden text-[var(--text-muted)] sm:inline" aria-hidden>
          ·
        </span>
        <NavLink to={`${PATH.legalRules}${suffix}`} className={linkClass}>
          Пользовательское соглашение
        </NavLink>
        <span className="hidden text-[var(--text-muted)] sm:inline" aria-hidden>
          ·
        </span>
        <NavLink to={`${PATH.legalPrivacy}${suffix}`} className={linkClass} title="Сводная информация об обработке и защите данных">
          Политика конфиденциальности
        </NavLink>
        {orgSlug ? (
          <>
            <span className="hidden text-[var(--text-muted)] sm:inline" aria-hidden>
              ·
            </span>
            <NavLink to={`${PATH.legalOrganization}${suffix}`} className={linkClass}>
              Соглашение с организацией
            </NavLink>
          </>
        ) : null}
        {accessToken ? (
          <>
            <span className="hidden text-[var(--text-muted)] sm:inline" aria-hidden>
              ·
            </span>
            <EmbedFeedbackButton variant="footer" />
          </>
        ) : null}
      </div>
    </footer>
  );
}
